// extracted by mini-css-extract-plugin
module.exports =  {"alginBrandIdButton":"alginBrandIdButton__KH7vy","flexContainer":"flexContainer__Hf3qg","flexItem":"flexItem__Sd47E","tip":"tip__AiEk0"};